import { ExtendedTreeNodeType } from '@features/campaigns/builder/components/FormFields/common/Tree/types/treeTypes';
import {
  collectGeoPayloadIds,
  GeoPayloadTreeNode,
} from '@features/campaigns/builder/components/FormFields/common/Tree/utils/collectGeoPayloadIds.ts';
import { GeoTargetingFormValues, GeoTargetingPayload } from '@features/campaigns/builder/shared/types/geoTargeting.ts';
import { getGeoTargetingConfig } from '@features/campaigns/shared/config/geoTargetingConfig.ts';
import {
  AgeGender,
  CampaignDetails,
  InterestSegments,
  OperationType,
  Provinces,
} from '@features/campaigns/shared/types/campaign';
import { UserCountryCode } from '@shared/types/countryCodes.ts';

const getIdsFromTreeNodes = (treeNodes: Provinces | AgeGender | InterestSegments | null): string[] => {
  const hasItemsWithLengthProp = treeNodes?.items && (treeNodes.items.length || treeNodes.items.length === 0);
  if (hasItemsWithLengthProp) {
    const ids = treeNodes.items.map((treeNode) => {
      return treeNode.id;
    });
    return ids;
  } else {
    const parsedTreeNodes = treeNodes as unknown as ExtendedTreeNodeType[];
    const ids = parsedTreeNodes?.map((treeNode) => {
      return treeNode.id;
    });
    return ids;
  }
};

export function getSelectedIdsFromTreeNodes(
  treeNodes: Provinces | AgeGender | InterestSegments | null,
): string[] | null {
  const ids = getIdsFromTreeNodes(treeNodes);

  return ids?.length > 0 ? ids : null;
}

export function createGeoTargetingPayloadDTO(
  { provinces, cities, provincesOperationType }: GeoTargetingFormValues,
  country: UserCountryCode,
): GeoTargetingPayload {
  let provincesValues: string[] | null;
  let citiesValues: string[] | null;
  if (Array.isArray(provinces)) {
    const geoTargetingConfig = getGeoTargetingConfig(country);
    const citiesProvincesValues = collectGeoPayloadIds(provinces as GeoPayloadTreeNode[], geoTargetingConfig);
    provincesValues = citiesProvincesValues.provincesIds.length > 0 ? citiesProvincesValues.provincesIds : null;
    citiesValues = citiesProvincesValues.citiesIds.length > 0 ? citiesProvincesValues.citiesIds : null;
  } else {
    provincesValues = getSelectedIdsFromTreeNodes(provinces);
    citiesValues = getSelectedIdsFromTreeNodes(cities);
  }

  return {
    provinces: provincesValues?.length ? { operationType: provincesOperationType, ids: provincesValues } : null,
    cities: citiesValues?.length ? { operationType: provincesOperationType, ids: citiesValues } : null,
  };
}

export function restoreGeoOperationType({ provinces, cities }: Pick<CampaignDetails, 'provinces' | 'cities'>) {
  if (cities) {
    return cities.operationType;
  }

  if (provinces) {
    return provinces.operationType;
  }

  return OperationType.INCLUDE;
}
